// Generated by purs version 0.15.15
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Halogen_VDom_DOM_Prop from "../Halogen.VDom.DOM.Prop/index.js";
import * as Halogen_VDom_StringRenderer from "../Halogen.VDom.StringRenderer/index.js";
import * as Halogen_VDom_StringRenderer_Util from "../Halogen.VDom.StringRenderer.Util/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var member = /* #__PURE__ */ Data_Set.member(Data_Ord.ordString);
var voidElements = /* #__PURE__ */ (function () {
    var names = [ "area", "base", "br", "col", "embed", "hr", "img", "input", "isindex", "keygen", "link", "meta", "param", "source", "track", "wbr" ];
    return Data_Set.fromFoldable(Data_Foldable.foldableArray)(Data_Ord.ordString)(names);
})();
var renderAttr = function (name) {
    return function (value) {
        return new Data_Maybe.Just(Halogen_VDom_StringRenderer_Util["escape"](name) + ("=\"" + (Halogen_VDom_StringRenderer_Util["escape"](value) + "\"")));
    };
};
var propNameToAttrName = function (v) {
    if (v === "htmlFor") {
        return "for";
    };
    if (v === "className") {
        return "class";
    };
    return v;
};
var renderProperty = function (name) {
    return function (prop) {
        var name$prime = propNameToAttrName(name);
        var v = Foreign.typeOf(Foreign.unsafeToForeign(prop));
        if (v === "string") {
            return renderAttr(name$prime)(prop);
        };
        if (v === "number") {
            return renderAttr(name$prime)(show(prop));
        };
        if (v === "boolean") {
            return new Data_Maybe.Just(Halogen_VDom_StringRenderer_Util["escape"](name$prime));
        };
        return Data_Maybe.Nothing.value;
    };
};
var renderProp = function (v) {
    if (v instanceof Halogen_VDom_DOM_Prop.Attribute) {
        return renderAttr(v.value1)(v.value2);
    };
    if (v instanceof Halogen_VDom_DOM_Prop.Property) {
        return renderProperty(v.value0)(v.value1);
    };
    if (v instanceof Halogen_VDom_DOM_Prop.Handler) {
        return Data_Maybe.Nothing.value;
    };
    if (v instanceof Halogen_VDom_DOM_Prop.Ref) {
        return Data_Maybe.Nothing.value;
    };
    throw new Error("Failed pattern match at Halogen.VDom.DOM.StringRenderer (line 27, column 14 - line 31, column 18): " + [ v.constructor.name ]);
};
var renderProps = /* #__PURE__ */ (function () {
    var $22 = Data_String_Common.joinWith(" ");
    var $23 = Data_Array.mapMaybe(renderProp);
    return function ($24) {
        return $22($23($24));
    };
})();
var getTagType = function (v) {
    if (member(v)(voidElements)) {
        return Halogen_VDom_StringRenderer.SelfClosingTag.value;
    };
    if (Data_Boolean.otherwise) {
        return Halogen_VDom_StringRenderer.NormalTag.value;
    };
    throw new Error("Failed pattern match at Halogen.VDom.DOM.StringRenderer (line 18, column 1 - line 18, column 36): " + [ v.constructor.name ]);
};
var render = function (renderWidget) {
    return Halogen_VDom_StringRenderer.render(getTagType)(renderProps)(renderWidget);
};
export {
    render
};
//# sourceMappingURL=index.js.map
